import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import Error from './sections/views/Error/Error'
import Loguin from './sections/views/Loguin/Loguin'
import Home from './sections/views/Home/Home'
import Comprobantes from './sections/views/Comprobantes/Comprobantes'
import GrillaFacturas from './sections/views/GrillaFacturas/GrillaFacturas'
import VisorPDFComprobanteTransferencia from './sections/components/moleculas/GrillaComprobantes/ComprobanteTransferencia/VisorPDFComprobanteTransferencia';
import VisorPDFCertificadoRetencion from './sections/components/moleculas/GrillaComprobantes/CertificadoRetencion/VisorPDFCertificadoRetencion';
import NuevaFactura from './sections/views/NuevaFactura/NuevaFactura';
import GrillaPagosSinFactura from './sections/views/GrillaPagosSinFactura/GrillaPagosSinFactura';
import NuevoPagoSinFactura from './sections/views/NuevoPagoSinFactura/NuevoPagoSinFactura';
import VisorAdjuntoThuban from './sections/components/moleculas/GrillaAdjuntos/VisorAdjuntoThuban';
import Prueba from './sections/components/moleculas/GrillaAdjuntos/Prueba';
import VisorAntecedentes from './sections/components/moleculas/FormularioAltaObservacion/VisorAntecedentes';
import GrillaAdjuntoSiniestroContainer from './sections/components/organismos/GrillaAdjuntoSiniestroContainer/GrillaAdjuntoSiniestroContainer';
import GrillaAdjuntoJuicioContainer from './sections/components/organismos/GrillaAdjuntoJuicioContainer/GrillaAdjuntoJuicioContainer';
import GrillaJuicios from './sections/views/GrillaJuicios/GrillaJuicios';
import DetalleJuicio from './sections/views/DetalleJuicio/DetalleJuicio';
import GrillaAdjuntoObservacion from './sections/components/moleculas/GrillaAdjuntos/GrillaAdjuntoObservacion';
import ActaAcuerdo from './sections/views/ActaAcuerdo/ActaAcuerdo';
import VisorCartasSiniestros from './sections/components/moleculas/FormularioAltaObservacion/VisorCartasSiniestros';
import VisorCartaSiniestro from './sections/components/moleculas/CartasSiniestros/VisorCartaSiniestro';

function App() {
    return (
        <div>
            <BrowserRouter>
                <Routes>
                    <Route exact path="/" element={<Loguin />} />
                    <Route exact path="/home" element={<Home/>} />
                    <Route exact path="/actaAcuerdo" element={<ActaAcuerdo />} />
                    <Route exact path="/comprobantes" element={<Comprobantes />} />
                    <Route exact path="/facturas" element={<GrillaFacturas />} />
                    <Route exact path="/nuevafactura" element={<NuevaFactura />} />
                    <Route exact path="/verFactura" element={<NuevoPagoSinFactura />} />
                    <Route exact path="/pagossinfactura" element={<GrillaPagosSinFactura />} />
                    <Route exact path="/nuevopago" element={<NuevoPagoSinFactura />} />
                    <Route exact path="/detallefactura" element={<NuevaFactura />} />
                    <Route exact path="/juicios" element={<GrillaJuicios />} />
                    <Route exact path="/detalleJuicio" element={<DetalleJuicio />} />                    
                    <Route path="/VisorPDFComprobanteTransferencia/:idLiquidacion/:nroFactura/:nroGestion" element={<VisorPDFComprobanteTransferencia/>} />
                    <Route path="/VisorPDFCertificado/:idLiquidacion/:nroGestion" element={<VisorPDFCertificadoRetencion/>} />
                    <Route path="/VisorCartaSiniestro/:idCarta" element={<VisorCartaSiniestro/>} />
                    <Route path="/VisorAdjuntoThuban/:idDocumento/:origen" element={<VisorAdjuntoThuban />} />
                    <Route path="/VisorAntecedentes/:idDenuncia" element={<VisorAntecedentes />}/>
                    <Route path="/VisorCartasSiniestros/:idDenuncia" element={<VisorCartasSiniestros />}/>
                    <Route path="/VisorDocDigSiniestro/:nroSiniestro" element={<GrillaAdjuntoSiniestroContainer />}/>
                    <Route path="/VisorDocDigJuicio/:idJuicio" element={<GrillaAdjuntoJuicioContainer />}/>
                    <Route path="/GrillaAdjuntoObservacion/:idObservacion" element={<GrillaAdjuntoObservacion />} />
                    <Route path="/prueba" element={<Prueba />} />
                    <Route path="/loguin" element={<Loguin />} />
                    <Route path="/sesion" element={<Error />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;